module.exports = __webpack_public_path__ + "static/img/p1_img4.e363311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1_img4.png
// module id = KOGr
// module chunks = 0